import { isEmpty, isNil, isNumber, isSymbol } from 'lodash-es';
// THIS FILE IS RIPPED FROM LODASH, it is not exposed in the lib by itself
// https://github.com/lodash/lodash/blob/4.7.0-npm-packages/lodash.sortby/index.js

/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */

/* istanbul ignore file */

export function compare(value: anyOk, other: anyOk): 1 | -1 | 0 {
  if (value !== other) {
    const valIsDefined = value !== undefined,
      valIsNull = value === null,
      valIsReflexive = value === value,
      valIsSymbol = isSymbol(value);

    const othIsDefined = other !== undefined,
      othIsNull = other === null,
      othIsReflexive = other === other,
      othIsSymbol = isSymbol(other);

    if (
      (!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
      (valIsSymbol &&
        othIsDefined &&
        othIsReflexive &&
        !othIsNull &&
        !othIsSymbol) ||
      (valIsNull && othIsDefined && othIsReflexive) ||
      (!valIsDefined && othIsReflexive) ||
      !valIsReflexive
    ) {
      return 1;
    }
    if (
      (!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
      (othIsSymbol &&
        valIsDefined &&
        valIsReflexive &&
        !valIsNull &&
        !valIsSymbol) ||
      (othIsNull && valIsDefined && valIsReflexive) ||
      (!othIsDefined && valIsReflexive) ||
      !othIsReflexive
    ) {
      return -1;
    }
  }
  return 0;
}

export function isEmptyStringOrNil(value: anyOk): boolean {
  if (value === '' || isNil(value)) {
    return true;
  }
  return false;
}

export function compareNullish(value: anyOk, other: anyOk): 1 | -1 | 0 {
  if (value == other) {
    return 0;
  } else if (isEmptyStringOrNil(value) && !isEmptyStringOrNil(other)) {
    return 1;
  }
  return -1;
}

/*
  isBlank(undefined) => true
  isBlank(null) => true
  isBlank('') => true
  isBlank([]) => true
  isBlank({}) => true
  isBlank(NaN) => true
  isBlank(0) => false    <--- this!
*/
export function isBlank(value: anyOk): boolean {
  return (isEmpty(value) && !isNumber(value)) || isNaN(value);
}
